import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Menu from './menu/menu';
import Header from './about/about';
import Section from './about/seactions';
import Card from './about/seaction1';
import CyberModules from './about/seaction2';
import Reviews from './about/sec4';
import Hero from './about/seaction5';
import Footer from './about/section6';
import MadAcademyLanding from './about/homemenu';
import MadCourses from './crs';
import CyberDashboard from './a';
import CyberSecurityLanding from './b';
import LearningDashboard from './c';
import PathsSection from './d';
import Cardss from './e';
import Pagess from './f';
import FAQ from './g';
import MainPage from './combine';
import MadHighlights from './mad';
import ContactPage from './contact';


function App() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Menu />

        <Routes>
          {/* Root route */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <Section />
                <Card />
                <CyberModules />
                <Reviews />
                <Hero />
                <Footer />
    
           
      
                              </>
            }
          />

          {/* Home route */}
          <Route path="/home" element={<MadAcademyLanding />} />
            <Route path="/courses" element={<MadCourses />} />
               <Route path="/about" element={<MainPage />} />
                <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
}

export default App;
